module.exports = __webpack_public_path__ + "static/media/SQS_Logo_50001.7c43851d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SQS_Logo_50001.svg
// module id = 296
// module chunks = 0